import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import './Index.css';
import { selectAuthenticated, selectUser, login } from '../features/auth/authSlice';
import Login from '../features/auth/Login';
import GenerarEstadisticas from './GenerarEstadisticas';


export default function Index () {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const authenticated = useSelector(selectAuthenticated);
    const user = useSelector(selectUser);
    
    useEffect(() => {
        if (!authenticated) {
            //navigate('/login');
            dispatch(login());
        }
    }, [authenticated]);

    /*
    useEffect(() => {
        dispatch(login());
    }, []);
    */    

    if (!authenticated) {
        return <Login/>;
    }

    return (
        <div className="index-container">
            <div className="index-header">
                <h2>¿Qué necesitas hacer?</h2>
                <p className="index-subtitle">Selecciona una de las siguientes opciones</p>
            </div>

            <div className="action-cards">
                <div className="action-card primary-action">
                    <div className="card-icon">📝</div>
                    <h3>Notificar un suceso</h3>
                    <p>Registra un nuevo informe o incidente</p>
                    <button onClick={() => navigate('/informe')}>Crear notificación</button>
                </div>

                { 
                    user && 'rol' in user && user.rol.find((element) => element === 'intern' || element === 'extern') && (
                        <div className="action-card">
                            <div className="card-icon">🔍</div>
                            <h3>Buscar informe o expediente</h3>
                            <p>Consulta informes y expedientes existentes</p>
                            <button onClick={() => navigate('/buscar')}>Buscar</button>
                        </div>
                    )
                }

                {
                    user && ('rol' in user) && user.rol.find((element) => element === 'admin') && (
                        <div className="action-card">
                            <div className="card-icon">👥</div>
                            <h3>Gestionar usuarios</h3>
                            <p>Administra usuarios y permisos del sistema</p>
                            <button onClick={() => navigate('/usuarios')}>Administrar</button>
                        </div>
                    )
                }

                {
                    user && user.responsable_spiyv === true && (
                        <div className="action-card">
                            <div className="card-icon">📊</div>
                            <h3>Generar estadísticas</h3>
                            <p>Descarga el informe estadístico del semestre</p>
                            <GenerarEstadisticas />
                        </div>
                    )
                }
            </div>
        </div>
    );
}